import React from 'react';
import { Table, Row, Col, Button, Dropdown, List, Tag, Pagination } from 'antd';
import { InfoCircleOutlined, CloseCircleOutlined, CheckCircleOutlined, EditOutlined, SettingOutlined, DownCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { getParamTable, _tableLogActivity } from '../../../lib/Helper';

class Desktop extends React.Component {
  componentDidMount() {
    this.props.fetchTable()
  }

  actionItems = (row, action, statusSiswa, props) => {
    const menuItems = [];

    if (action.detail) {
      menuItems.push({
        key: '0',
        label: (
          <Link to={`/peserta-didik/${statusSiswa}/detail/${row.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <InfoCircleOutlined /> Detail
          </Link>
        ),
      });
    }

    if (action.update) {
      menuItems.push({
        key: '1',
        label: (
          <span onClick={() => props.modalPenagguhan(true, row)}>
            <EditOutlined /> Ubah Status Penangguhan
          </span>
        ),
      });
    }

    if (action.delete && statusSiswa === 'aktif') {
      menuItems.push({
        key: '2',
        label: (
          <span onClick={() => props.modalDelete(true, row)}>
            <CloseCircleOutlined /> Non Aktifkan
          </span>
        ),
      });
    }

    if (action.restore && statusSiswa === 'non-aktif') {
      menuItems.push({
        key: '3',
        label: (
          <span onClick={() => props.modalRestore(row)}>
            <CheckCircleOutlined /> Aktifkan
          </span>
        ),
      });
    }

    return menuItems;
  };

  render() {
    const { table } = this.props.state
    const statusSiswa = this.props.statusSiswa
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  sorter: false,
                  width: '2%',
                },
                {
                  title: 'Peserta Didik',
                  dataIndex: 'ttl',
                  width: '20%',
                  render: (a, row) => <List.Item style={{ padding: 0 }}>
                    <List.Item.Meta
                      title={row.nama}
                      description={<small>
                        NISN: {row.nisn ? row.nisn : "-"}
                        {/* NIS: {row.nis ? row.nis : "-"} */}
                      </small>}
                    />
                  </List.Item>,
                },
                {
                  title: 'Jenis Kelamin',
                  dataIndex: 'jenis_kelamin',
                  sorter: false,
                },
                {
                  title: 'Tempat/Tgl Lahir',
                  dataIndex: 'ttl',
                  sorter: false,
                  render: (a, row) => <List.Item style={{ padding: 0 }}>
                    <List.Item.Meta
                      title={row.tempat_lahir}
                      description={<small>{row.tgl_lahir}</small>}
                    />
                  </List.Item>,
                },
                {
                  title: 'Rombel',
                  dataIndex: 'rombel_nama',
                  sorter: false,
                },
                {
                  title: 'Status',
                  dataIndex: 'ttl',
                  sorter: false,
                  render: (a, row) => <>
                    {row.status_siswa === "Aktif" ? <Tag color="blue" icon={<CheckCircleOutlined />}>Aktif</Tag> : <Tag color="red" icon={<CloseCircleOutlined />}>Tidak Aktif</Tag>}
                  </>,
                },
                {
                  title: 'Status Penangguhan',
                  dataIndex: 'akun_ditangguhkan',
                  sorter: false,
                  render: (a, row) => <>
                    {row.akun_ditangguhkan === "0" ? "-" : <Tag color="red">Ditangguhkan</Tag>}
                  </>,
                },
                {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (_, row) => (
                    <Dropdown menu={{ items: this.actionItems(row, action, statusSiswa, this.props) }} trigger={['click']}>
                      <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                    </Dropdown>
                  )
                },
                {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default Desktop;
